<div class="row text-center">
    <div class="col-lg-4">
        <h2>Customer Actions ({{view.total}})</h2>
    </div>
    <div class="col-lg-2">
        <label>Begin Date:</label>
        <kendo-datepicker [(ngModel)]="beginDate" style="margin: 2px;" (blur)="onDateChange($event)"></kendo-datepicker>
    </div>
    <div class="col-lg-2">
        <label>End Date:</label>
        <kendo-datepicker [(ngModel)]="endDate" style="margin: 2px;" (blur)="onDateChange($event)"></kendo-datepicker>
    </div>
</div>

<div class="row">
    <div class="col-sm-12">
        <epi-container [header]="'Action Type Totals'">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-sm-2 dashboard-card" *ngFor="let actionTypeCard of actionTypeCards">
                        <h3>{{actionTypeCard.actionTypeDesc}}</h3>
                        <h3>{{actionTypeCard.total}}</h3>
                    </div>
                </div>
            </div>
        </epi-container>
    </div>
</div>

<div class="row">
    <div class="col-lg-12">
        <kendo-grid [data]="view"
                    [pageSize]="state.take"
                    [skip]="state.skip"
                    [sort]="state.sort"
                    [filter]="state.filter"
                    [sortable]="true"
                    [pageable]="{
                    pageSizes: pageSizes
                }"
                    [filterable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-span-column>
                <kendo-grid-column field="customerName" title="Name" width="50"></kendo-grid-column>
                <kendo-grid-column field="customerCode" title="Code" width="50"></kendo-grid-column>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <a href="/#/customer-detail/{{dataItem.customerCode}}" target="_blank">{{dataItem.customerName}} <br /> {{dataItem.customerCode}}</a>
                </ng-template>
            </kendo-grid-span-column>
            <kendo-grid-column field="transactionDate" title="Date" filter="date" format="{0:d}" width="120">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.transactionDate | date:'shortDate'}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="actionTypeDescription" title="Type" width="60"></kendo-grid-column>
            <kendo-grid-column field="contactName" title="Contact" width="60"></kendo-grid-column>
            <kendo-grid-column field="createdByEmployeeName" title="Created By" width="60"></kendo-grid-column>
            <kendo-grid-column field="customerActionNotes" title="Details" width="400"></kendo-grid-column>
        </kendo-grid>
    </div>
</div>
